import React, { useState } from "react";
import useDBO from "../../../hooks/useDBO";
import Loca from "../../../components/Loca";
import Time from "../../../components/Time";
import Lang from "../../../components/Lang";
import Loading from "../../../Loading";
import "../Home.css";
import UserShifts from "../UserShifts";
import HtClass from "../../../components/HtClass";
import { Clock, School, MapPin } from "lucide-react";


export default function TodayShifts({ user }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [year] = useState(new Date().getFullYear());
  const [month] = useState(new Date().getMonth());
  const shifts = useDBO(`/my-shifts/${user._id}/${year}/${month}`);

  if (shifts.loading) return <Loading />;
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const displayShifts = (shifts.get || []).filter((shift) => {
    const shiftDate = new Date(shift.tDate);
    shiftDate.setHours(0, 0, 0, 0);
    return shiftDate.getTime() === today.getTime();
  });

  const totalHours = displayShifts.reduce((acc, shift) => acc + (parseFloat(shift.hours) || 0), 0);

  return (
    <div className="home-widget user-shifts-widget flex flex-col h-full bg-white border border-slate-200 rounded-[24px] shadow-sm overflow-hidden relative">
      <div className={`px-4 py-3 flex justify-between items-center bg-slate-50 shrink-0 ${displayShifts.length > 0 ? "border-b border-slate-100" : ""}`}>
        <div className="flex flex-col">
          <h3 className="font-heading text-[1.1rem] font-semibold text-slate-900 flex items-center gap-2">
            <Clock size={20} className={`text-teal-800`} />
            <Lang w="todayShifts" />
          </h3>
        </div>
        <div className="flex items-center gap-3">
          <button 
            className="bg-white hover:bg-slate-50 text-slate-700 font-bold py-1 px-3 rounded-lg text-[0.6rem] border border-slate-200 shadow-sm transition-all active:scale-95 cursor-pointer uppercase tracking-tighter"
            onClick={() => setIsModalOpen(true)}
          >
            <Lang w="thisMonth" />
          </button>
          <div className="flex items-center gap-2 bg-teal-600 text-white px-3 py-1 rounded-lg shadow-sm">
            <span className="text-sm font-black leading-none">{totalHours}</span>
            <span className="text-[0.6rem] font-bold opacity-80 uppercase tracking-tighter">
              <Lang w="hrs" />
            </span>
          </div>
        </div>
      </div>
      
      {/* Scrollable container with vertical limit for high-density view */}
      {displayShifts.length > 0 && (
        <div className="flex-1 overflow-y-auto p-3 bg-white max-h-[300px] scrollbar-slim">
           <div className="flex flex-col gap-2">
             {displayShifts.map((shift) => (
               <div key={shift._id} className="flex items-center justify-between gap-4 p-2.5 bg-slate-50/50 rounded-xl border border-slate-100 hover:border-teal-100 hover:bg-teal-50/30 transition-all group">
                 <div className="flex items-center gap-3 flex-1 overflow-hidden">
                   <div className="shrink-0 text-[0.65rem] font-[800] text-slate-500 bg-white px-2 py-1.5 rounded-lg border border-slate-200 shadow-sm whitespace-nowrap min-w-[100px] text-center">
                     <Time time={shift.startTime} /> - <Time time={shift.endTime} />
                   </div>
                   
                   <div className="flex flex-col min-w-0">
                      <div className="font-[800] text-slate-800 text-[0.7rem] leading-tight truncate">
                        {shift.role || <Lang w="standardShift" />}
                      </div>
                      {shift.htClass && (
<div className="text-[0.6rem] font-[800] text-teal-600 flex items-center gap-1 mt-0.5 truncate">
                           <School size={12} />
                           <HtClass htClass={shift.htClass} link />
                         </div>
                      )}
                   </div>
                 </div>
 
                 <div className="flex items-center gap-4 shrink-0">
<div className="text-[0.65rem] font-bold text-slate-400 flex items-center gap-1.5 bg-white/60 px-2 py-1 rounded-md">
                      <MapPin size={10} className="opacity-70" />
                      <span className="max-w-[70px] truncate">
                        {typeof shift.location === 'string' && shift.location.length > 20 ? <Loca id={shift.location} /> : shift.location}
                      </span>
                    </div>
                   <div className="bg-white border border-slate-200 w-8 h-8 flex items-center justify-center rounded-lg font-black text-slate-700 text-[0.65rem] shadow-sm transform group-hover:scale-105 transition-transform">
                     {shift.hours}h
                   </div>
                 </div>
               </div>
             ))}
           </div>
        </div>
      )}

      <UserShifts user={user} open={isModalOpen} setOpen={setIsModalOpen} />
    </div>
  );
}
